/**
 * Identity of an applied hanging protocol.
 *
 * Deliberately import-free: the toolbar components that need this also import
 * Constants, and Constants sits in an import cycle with the viewer components.
 * Reaching hpKey through legacyHangAdapter (which reads Constants at module
 * scope) evaluated that cycle in the wrong order and threw "Cannot access
 * HP_VIEWPORT_ALIGNMENT before initialization". A leaf module cannot.
 */

/**
 * Key an applied protocol takes in hpViewportMap, and the identity the viewer
 * menu ticks. v1 protocol names are unique per user so the name serves; v2
 * categories are only unique within their group, so two same-named categories
 * would otherwise overwrite each other's viewport assignments.
 */
export const hpKey = (hp) => (hp?.v2 ? `${hp.groupId}:${hp.categoryId}` : hp?.name);
